/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcInventoryV1FirmOrderEvent } from '@interxfi/types';
import { schema } from 'normalizr';
import { ixcAssetsV1AssetStateEntity } from './ixc-assets-v1-asset-state';

export const IXC_INVENTORY_V1_FIRM_ORDER_EVENT_ENTITY_NAME = 'ixc.inventory.v1.FirmOrderEvent';
export const ixcInventoryV1FirmOrderEventEntity = new schema.Entity<IxcInventoryV1FirmOrderEvent>(IXC_INVENTORY_V1_FIRM_ORDER_EVENT_ENTITY_NAME, {
    event: new schema.Object({
        submitted: new schema.Object({
            asset: ixcAssetsV1AssetStateEntity
        })
    })
}, { idAttribute: (entity: IxcInventoryV1FirmOrderEvent) => `${entity.metadata?.eventId}` });

